import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import Shared from 'screens/shared';
import { Paper } from '@mui/material';
import CreateForm from 'screens/monitoring/actions-list/create';
import { Redirect } from 'react-router-dom';
import {
  ROUTE,
} from 'constant';
import { MonitoringAction } from 'models';
import FiringActions from './firing-actions';

export const MonitoringActionDetails = ({ match = {} }) => {
  const { params = {} } = match;
  const { id: actionId = '' } = params;

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const {
    [ACTIONS_TYPES.MONITORING.ACTION.GET]: _monitoringAction = {},
  } = useSelector((e) => e);

  const [, successes] = Shared.hooks.useNotification({
    actions: [ACTIONS_TYPES.MONITORING.ACTION.DELETE],
  });

  const monitoringAction = new MonitoringAction(_monitoringAction);

  useEffect(() => {
    if (actionId) {
      actions.monitoring.action.get({ id: actionId });
    }
  }, [actionId]);

  useEffect(() => {
    actions.common.setLayoutTitle({
      layout: { title: 'Monitoring Action', menu: ROUTE.DASHBOARD.MONITORING.key },
    });
  }, []);

  const onDelete = (isDelete) => {
    setShowConfirmDialog(false);
    if (isDelete) {
      actions.monitoring.action.delete({ id: actionId });
    }
  };

  const {
    name = '', typeProperties = {},
  } = monitoringAction.getProperties();

  const {
    emailTo = '',
  } = typeProperties;

  return (
    <div className="screen-server">
      <div className="strap">
        <div className="strap-details">
          <Shared.widgets.Icon name="paper-plane" style={{ fontSize: 30 }} />
          <div style={{ marginLeft: 15 }}>
            <span style={{ display: 'block', marginLeft: 0 }} className="strap-details-title">
              {name}
            </span>

            <span
              style={{
                display: 'flex', justifyItems: 'center', marginTop: 4,
              }}
            >
              <span>
                <Shared.widgets.Icon name="envelope" style={{ fontSize: 12 }} />
                <span style={{ marginLeft: 5, fontSize: 12 }}>
                  {emailTo}
                </span>
              </span>
            </span>
          </div>
        </div>
        <div className="strap-details-icons">
          <Shared.widgets.Icon
            name="trash"
            className="danger-txt"
            onClick={() => setShowConfirmDialog(true)}
          />
          <Shared.widgets.Icon
            name="edit"
            onClick={() => setIsUpdate(!isUpdate)}
          />
        </div>
      </div>
      {isUpdate && (
        <Paper>
          <CreateForm
            monitoringAction={monitoringAction}
            onCancel={() => setIsUpdate(false)}
          />
        </Paper>
      )}

      <FiringActions actionId={actionId} />
      <Shared.dialog.Confirm show={showConfirmDialog} onClose={onDelete} />
      {!!successes.length && <Redirect to={ROUTE.DASHBOARD.MONITORING_ACTIONS.path} />}
    </div>
  );
};
